import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgxsModule } from "@ngxs/store";
import { PipesModule } from "@vattenfall/core";
import { UiModule } from "@vattenfall/ui";

import { MySelectElectricityProductComponent } from "./my-select-electricity-product.component";
import { MySelectElectricityProductState } from "./my-select-electricity-product.state";

@NgModule({
  declarations: [MySelectElectricityProductComponent],
  imports: [CommonModule, FormsModule, PipesModule, UiModule, NgxsModule.forFeature([MySelectElectricityProductState])],
  bootstrap: [MySelectElectricityProductComponent],
  exports: [MySelectElectricityProductComponent],
})
export class MySelectElectricityProductModule {}
